<template>
  <v-card class="rounded-lg pa-2 white" flat>
    <v-card-title class="secondary--text"> نمودار تعداد <span class="ml-1 mr-1 info--text"> خرید</span>  و برگشتی
      <v-spacer></v-spacer>
        <chart-export-btn page-chart-id="total-buy-chart"></chart-export-btn>
    </v-card-title>
    <canvas height="110" id="total-buy-chart"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";
export default {
  name: 'TotalBuyOfMonthChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartResult : null,
      chartData: {
        type: "bar",
        data: {
          labels: [],
          datasets: [
            {
              label: "خرید",
              data: [],
              backgroundColor: "rgba(1, 158, 246, .3)",
              borderColor: "#019EF6",
              borderWidth: 3,
              hoverBorderWidth:5
            },
            {
              label: "برگشتی",
              data: [],
              borderColor: "#F1416C",
              backgroundColor: "rgba(241, 65, 108, .3)",
              borderWidth: 3,
              hoverBorderWidth:5
            },
          ]
        },
        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          responsive: true,
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              }
            }],
            yAxes: [
              {
                gridLines: {
                  color: "rgba(161, 161, 161, .10)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15
                }
              }
            ]
          }
        }
      }
    }
  },
  methods : {
    getChartFromApi(){
      this.request({
        url: this.endpoint(`reports/buySaleChartReport/buy`),
        method: "get",
        success: data => {
          this.chartResult = data.results
          this.getData()
        }
      })
    },

    getData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  13
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []
      this.chartData.data.datasets[1].data = []

      for (let month of this.chartResult){
        this.chartData.data.labels.push(month.title)
        this.chartData.data.datasets[0].data.push(month.sum)
        this.chartData.data.datasets[1].data.push(month.back)

      }
      this.getChart()
    },
    getChart(){
      const ctx = document.getElementById('total-buy-chart');
      new Chart(ctx, this.chartData);
    }

  },

  mounted() {
    this.getChartFromApi()
  },

}
</script>